/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Measures_TitleInputs */

const en_us2_body_measures_title = /** @type {(inputs: Body_Measures_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Measurements`)
};

const pt_br2_body_measures_title = /** @type {(inputs: Body_Measures_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medidas`)
};

const es_419_body_measures_title = /** @type {(inputs: Body_Measures_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medidas`)
};

const pt_pt2_body_measures_title = /** @type {(inputs: Body_Measures_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medidas`)
};

const fr_fr2_body_measures_title = /** @type {(inputs: Body_Measures_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensurations`)
};

const de_de2_body_measures_title = /** @type {(inputs: Body_Measures_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umfänge`)
};

const it_it2_body_measures_title = /** @type {(inputs: Body_Measures_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Misure`)
};

/**
* | output |
* | --- |
* | "Measurements" |
*
* @param {Body_Measures_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_measures_title = /** @type {((inputs?: Body_Measures_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Measures_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_measures_title(inputs)
	if (locale === "es-419") return es_419_body_measures_title(inputs)
	if (locale === "pt-PT") return pt_pt2_body_measures_title(inputs)
	if (locale === "fr-FR") return fr_fr2_body_measures_title(inputs)
	if (locale === "de-DE") return de_de2_body_measures_title(inputs)
	if (locale === "it-IT") return it_it2_body_measures_title(inputs)
	return en_us2_body_measures_title(inputs)
});
export { body_measures_title as "body-measures.title" }